import React, { useEffect } from 'react';
import { change, getFormValues } from 'redux-form';
import { TextareaAutosize } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import { connect, useDispatch } from 'react-redux';
import useStyles from '../styles/styles';

const formName = 'battery-form';

const PeCustomerNote = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [editText, setEditText] = React.useState(props.formValues?.customer_note);

    const handleChange = event => {
        setEditText(event.target.value);
    };

    useEffect(() => {
        dispatch(change(formName, 'customer_note', editText));
    }, [dispatch, editText]);

    return (
        <div className={classes.control}>
            <FormControl variant="outlined" fullWidth>
                <h3 className={classes.label}>Write your own:</h3>
                <TextareaAutosize
                    id={'customer_note'}
                    name={'customer_note'}
                    className={classes.textArea}
                    onChange={handleChange}
                    value={editText}
                    style={{
                        fontSize: '14px',
                        fontWeight: 400,
                        padding: '10px',
                    }}
                    placeholder={'Notes'}
                />
            </FormControl>
        </div>
    );
};

export default connect(state => ({
    formValues: getFormValues(formName)(state)
}))(PeCustomerNote);